import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/contexts/auth-context';
import { ShieldAlert, ArrowLeftRight, } from '@/components/icons';

export const ImpersonationBanner: React.FC = () => {
  const { t } = useTranslation();
  const { isImpersonating, user, impersonatedByName, exitImpersonation } = useAuth();

  if (!isImpersonating || !user) return null;

  return (
    <div className="sticky top-0 z-50 flex items-center justify-between px-4 py-2 bg-indigo-950/95 border-b border-indigo-700/80 text-indigo-100 shadow-md animate-in slide-in-from-top duration-300">
      <div className="flex items-center gap-2 text-sm font-medium">
        <ShieldAlert className="w-5 h-5 text-indigo-400 animate-pulse shrink-0" />

        <span>
          <strong>{t('common.impersonation_badge')}</strong> {t('common.impersonation_viewing')}{' '}
          <span className="underline font-semibold">{user.full_name}</span> ({user.email} &bull; {user.role})
          {impersonatedByName ? ` ${t('common.impersonation_initiated_by', { name: impersonatedByName })}` : ''}
        </span>
      </div>
      <button
        onClick={exitImpersonation}
        className="flex items-center gap-1.5 px-3 py-1 bg-white/20 hover:bg-white/30 active:bg-white/40 text-white text-xs font-semibold rounded-md border border-white/30 backdrop-blur-sm transition-all shadow-sm"
      >
        <ArrowLeftRight className="w-3.5 h-3.5" />
        {t('common.impersonation_exit')}
      </button>
    </div>

  );
};
